export default "__VITE_ASSET__CLgL8Smn__"